import { DTO, MapFromDTO, Mapper, Required } from '@bp/shared/models/metadata';
import { SubscriptionPlan, SubscriptionPlanChargePeriod } from '@bp/shared/domains/subscription-plans/core';
import { Currency } from '@bp/shared/models/currencies';

import { SubscriptionPlanCheckoutPaymentInformationFormVm } from './subscription-plan-checkout-payment-information-form-vm';

export class SubscriptionPlanPurchase extends SubscriptionPlanCheckoutPaymentInformationFormVm {

	@Mapper(SubscriptionPlanChargePeriod)
	chargePeriod!: SubscriptionPlanChargePeriod;

	@Required()
	subscriptionPlan!: SubscriptionPlan;

	@MapFromDTO()
	currency!: Currency;

	readonly subscriptionId: string;

	constructor(dto?: DTO<SubscriptionPlanPurchase>) {
		super(dto);

		this.subscriptionId = this.subscriptionPlan.id!;
	}

}
